// extracted by mini-css-extract-plugin
export default {"desc":"Nft_desc__ia-Lh","button":"Nft_button__HpMr4","title":"Nft_title__kVjev","text":"Nft_text__4XG2e","collections":"Nft_collections__FQzbm"};